import {
  Snackbar as MuiSnackbar,
  Alert,
  AlertTitle,
  Button,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface SnackBarProps {
  type: 'success' | 'warning' | 'error' | 'info';
  title?: string;
  message: string;
  duration?: number | null | undefined;
  open: boolean;
  onClose: () => void;
  action?: () => void;
  actionLabel?: string;
}

export function Snackbar({
  type,
  title,
  message,
  duration,
  open,
  onClose,
  action,
  actionLabel,
}: SnackBarProps) {
  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={duration}
      open={open}
      onClose={onClose}
      key={message}
    >
      <Alert
        onClose={onClose}
        severity={type}
        variant="filled"
        icon={false}
        sx={{ width: '100%', whiteSpace: 'pre-line' }}
        action={
          actionLabel &&
          action && (
            <Box>
              <Button color="inherit" size="small" onClick={action}>
                <Typography color="secondary.contrastText">{actionLabel}</Typography>
              </Button>
              <IconButton color="inherit" size="small" onClick={onClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          )
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </MuiSnackbar>
  );
}

export default Snackbar;
